/* eslint-disable camelcase */
import firebase from 'firebase/compat/app';
import 'firebase/compat/firestore';
import 'firebase/compat/analytics';

/* Log environment */
let env = process.env.REACT_APP_ENV ? process.env.REACT_APP_ENV : process.env.NODE_ENV;
console.log('ENVIRONMENT: ', env);

let firebaseConfig = {};

/* Connect to firebase project test (includes demo) */
if (env === 'development' || env === 'test' || env === 'demo') {
	firebaseConfig = {
		apiKey: 'AIzaSyBjB8vvnG3KBFf52s92S-T2yGsp-g3TV4k',
		authDomain: 'cgl-tshirt-test.firebaseapp.com',
		projectId: 'cgl-tshirt-test',
		storageBucket: 'cgl-tshirt-test.appspot.com',
		messagingSenderId: '794127970796',
		appId: '1:794127970796:web:b90c46d7d904d4bcd690c9'
	};
}

/* Connect to firebase: production */
if (env === 'production') {
	firebaseConfig = {
		apiKey: 'AIzaSyAbi4RiRVvZeyW9dWJbspig6UFtzcpx10g',
		authDomain: 'cgl-tshirt-production.firebaseapp.com',
		projectId: 'cgl-tshirt-production',
		storageBucket: 'cgl-tshirt-production.appspot.com',
		messagingSenderId: '491996667417',
		appId: '1:491996667417:web:445c75adee243c21be9488'
	};
}


/* Initialize firebase */
firebase.initializeApp(firebaseConfig);



export default firebase.firestore;